// extracted by mini-css-extract-plugin
module.exports = {"container":"PinPluginItem_container__3o9oY","item":"PinPluginItem_item__3X6X8","detailsBtn":"PinPluginItem_detailsBtn__KBnsX"};